// extracted by mini-css-extract-plugin
export default {"heading":"Base_heading__wGgik","subheading":"Base_subheading__xHAtx","baseOuterContainer":"Base_baseOuterContainer__0Z13X"};